import React from "react";
import EditEntrySquarePayment from "./EditEntrySquarePayment.jsx";
import I18n from "i18n-js";
import './translations.js';

class EditEntryPayment extends React.Component {
  constructor(props) {
    super(props);
    this.total_owing_f = Number(parseFloat(this.props.entry_total_owing) > 0 ? parseFloat(this.props.entry_total_owing) : 0.00).toFixed(2);
    this.state = {
      isMulti: (this.props.isMulti == true) ? true : false,
      customAmount: this.total_owing_f,
      riders: this.props.riders
    };
    this.updateTotalOwing = this.updateTotalOwing.bind(this)
    I18n.locale = this.props.locale
  }

  updateInputValue(evt) {
    this.setState({customAmount: evt.target.value});
  }

  updateTotalOwing(amount){
    this.total_owing_f = amount
    this.state.customAmount = amount
    jQuery('#entry-custom-payment-input').val(amount)
  }

  render() {
    return (
      <div>
        <div>
          {this.state.riders && this.state.riders.length > 1 &&
              <table className="table table-striped">
                <thead>
                  <th>{I18n.t("reports.rider")}</th>
                  <th>{I18n.t("fees.total", {item: null})}</th>
                  <th></th>
                </thead>
                <tbody>
                  {this.state.riders.map((rider, index) =>
                    <tr key={index}>
                      <td>{rider[0]}</td>
                      <td>${rider[1].toFixed(2)}</td>
                      <td>
                        <button type="button" className="btn btn-primary"
                                onClick={() => this.setState({customAmount: rider[1]})}>Pay This Amount
                        </button>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td>{I18n.t("fees.total_owing")}</td>
                    <td>${Number(this.total_owing_f).toFixed(2)}</td>
                    <td><button type="button" className="btn btn-primary" onClick={() => this.setState({customAmount: this.total_owing_f})}>{I18n.t("fees.total_owing")}</button></td>
                  </tr>
                </tbody>
              </table>
          }
          {this.state.isMulti == false &&
              (
                  <div>
                    <h5>{I18n.t("wizard.payment_amount_enter")} ${Number(this.total_owing_f).toFixed(2)} owed</h5>

            <p>{I18n.t("wizard.payment_amount")}<input size="5" id="entry-custom-payment-input" inputMode="numeric" pattern="^\d*(\.\d{0,2})?$"
            value={Number(this.state.customAmount).toFixed(2)} onChange={evt => this.updateInputValue(evt)} type="number" step="0.01"/></p>
                  </div>
              )}
          <div>
            <EditEntrySquarePayment
                customAmount={this.state.customAmount}
                entry_total_owing={this.total_owing_f}
                locale={this.props.locale}
                updateTotalOwing={this.updateTotalOwing}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default EditEntryPayment
